// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3QAI2","content":"styles_content__3TyPT","checkbox":"styles_checkbox__uEywE","checkboxLabel":"styles_checkboxLabel__2ErE8"};